<template>
    <div v-if="popular" class="h-full flex flex-col rounded-lg shadow-lg lg:rounded-none lg:rounded-l-lg relative">
        <div class="flex-1 flex flex-col">
            <div class="pointer-events-none absolute inset-0 rounded-lg border-2 border-racing-stars-yellow transition duration-500 ease-in-out dark:border-racing-stars-yellow" aria-hidden="true" />
            <div class="absolute inset-x-0 top-0 translate-y-px">
                <div class="flex justify-center -translate-y-1/2">
                    <span class="inline-flex rounded-full bg-racing-stars-yellow px-4 py-1 text-sm font-semibold tracking-wider uppercase text-white transition duration-500 ease-in-out dark:bg-racing-stars-yellow text-gray-800">
                        Best Value
                    </span>
                </div>
            </div>
            <div class="bg-white px-6 pt-8 pb-4 transition duration-500 ease-in-out dark:bg-gray-900">
                <div>
                    <h3 class="text-center text-2xl font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white" id="tier-growth">
                        {{ tokens + parseInt(package.free_tokens) }} Tokens
                    </h3>
                    <h4 class="text-center text-1xl font-semibold text-gray-900 sm:-mx-6 transition duration-500 ease-in-out dark:text-white" id="tier-growth">
                        Includes {{ package.free_tokens }} Free {{ pluralise('Token', package.free_tokens) }}
                    </h4>
                    <div class="mt-1 flex items-center justify-center">
                        <span class="px-3 flex items-start text-3xl tracking-tight text-gray-900 sm:text-6xl transition duration-500 ease-in-out dark:text-white">
                            <span class="font-medium" v-text="formatter.format(price)" />
                        </span>
                    </div>
                </div>
            </div>
            <div class="flex-1 flex flex-col justify-between border-t-2 border-gray-100 p-4 bg-gray-50 sm:p-10 lg:p-6 xl:p-10 transition duration-500 ease-in-out dark:border-gray-600 dark:bg-gray-800">
                <ul role="list" class="space-y-4">
                    <li v-for="feature in features" :key="feature" class="flex items-start">
                        <div class="shrink-0">
                            <CheckIcon class="shrink-0 h-6 w-6 text-green-500 transition duration-500 ease-in-out dark:text-racing-stars-yellow" aria-hidden="true" />
                        </div>
                        <p class="ml-3 text-base font-medium text-gray-500 transition duration-500 ease-in-out dark:text-white">
                            {{ feature }}
                        </p>
                    </li>
                </ul>
                <div class="mt-2">
                    <div class="rounded-lg shadow-md">
                        <button type="submit" class="block w-full text-center rounded-lg border border-transparent bg-racing-stars-yellow px-6 py-3 text-xl leading-6 font-medium text-white hover:bg-racing-stars-yellow transition duration-500 ease-in-out dark:hover:bg-gray-900 dark:bg-racing-stars-yellow dark:text-gray-800 dark:hover:text-white text-gray-800" aria-describedby="tier-growth">
                            {{ buttonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="h-full flex flex-col rounded-lg shadow-lg overflow-hidden lg:rounded-none" :class="[position === 'left' ? 'lg:rounded-l-lg' : 'lg:rounded-r-lg']">
        <div class="flex-1 flex flex-col">
            <div class="bg-white px-6 pt-8 pb-4 transition duration-500 ease-in-out dark:bg-gray-900">
                <div>
                    <h3 class="text-center text-2xl font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white" id="tier-hobby">
                        {{ tokens + parseInt(package.free_tokens) }} Tokens
                    </h3>
                    <h4 class="text-center text-1xl font-semibold text-gray-900 sm:-mx-6 transition duration-500 ease-in-out dark:text-white" id="tier-growth">
                        Includes {{ package.free_tokens }} Free {{ pluralise('Token', package.free_tokens) }}
                    </h4>
                    <div class="mt-1 flex items-center justify-center">
                        <span class="px-3 flex items-start text-3xl tracking-tight text-gray-900 transition duration-500 ease-in-out dark:text-white">
                            <span class="font-medium" v-text="formatter.format(price)" />
                        </span>
                    </div>
                </div>
            </div>
            <div class="flex-1 flex flex-col justify-between border-t-2 border-gray-100 p-4 bg-gray-50 sm:p-10 lg:p-6 xl:p-10 transition duration-500 ease-in-out dark:border-gray-600 dark:bg-gray-800">
                <ul role="list" class="space-y-4">
                    <li v-for="feature in features" :key="feature" class="flex items-start">
                        <div class="shrink-0">
                            <CheckIcon class="shrink-0 h-6 w-6 text-green-500 transition duration-500 ease-in-out dark:text-racing-stars-yellow" aria-hidden="true" />
                        </div>
                        <p class="ml-3 text-base font-medium text-gray-500 transition duration-500 ease-in-out dark:text-white">
                            {{ feature }}
                        </p>
                    </li>
                </ul>
                <div class="mt-2">
                    <div class="rounded-lg shadow-md">
                        <button type="submit" class="block w-full text-center rounded-lg border border-transparent bg-white px-6 py-3 text-base font-medium text-gray-800 hover:bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900 dark:text-white dark:hover:bg-racing-stars-yellow dark:hover:text-gray-800" aria-describedby="tier-hobby">
                            {{ buttonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CheckIcon } from '@heroicons/vue/outline'

const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
});

export default {
    components: {
        CheckIcon
    },

    props: {
        buttonText: String,
        popular: Boolean,
        tokens: Number,
        package: Object,
        price: Number,
        position: String,
        features: {}
    },

    setup() {
        const pluralise = (singular, tokens) => {
            return tokens == 1 ? singular : singular + 's'
        }

        return {
            formatter,
            pluralise,
        }
    }
}

</script>
